import Home from '@/pages/Home'
import StoreFinder from '@/pages/StoreFinder'
import ArchiveServices from '@/pages/ArchiveServices'
import ArchivePosts from '@/pages/ArchivePosts'
import Service from '@/pages/Service'
import Post from '@/pages/Post'
import Metodo from '@/pages/Metodo'
import Assicurazioni from '@/pages/Assicurazioni'
import Garanzia from '@/pages/Garanzia'
import Processo from '@/pages/Processo'
import Vantaggi from '@/pages/Vantaggi'
import CarClinic from '@/pages/CarClinic'
import CentriBS from '@/pages/CentriBS'
import SimplePage from '@/pages/SimplePage'
import Contact from '@/pages/Contact'
import About from '@/pages/About'
import NotFound from '@/pages/NotFound'

export default (routing, lang) => [
  {
    key: 0,
    path: `/${lang}`,
    exact: true,
    component: () => <Home stub={routing.find((r) => r.cpt === 'home')?.slug} cpt="assicurazioni" />,
  },
  {
    key: 1,
    path: routing.map((route) => {
      if (route.cpt === 'page') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: SimplePage,
  },
  {
    key: 2,
    path: routing.map((route) => {
      if (route.cpt === 'metodo') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: Metodo,
  },
  {
    key: 3,
    path: `/${lang}${routing.find((r) => r.cpt === 'service')?.slug}`,
    component: () => (
      <Service
        cpt="service"
        tax="_cta_service_category"
      />
    ),
  },
  {
    key: 4,
    path: routing.map((route) => {
      if (route.cpt === '_cta_service_category') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <ArchiveServices
        stub={routing.find((r) => r.cpt === '_cta_service_category')?.slug}
        tax="_cta_service_category"
        cpt="service"
      />
    ),
  },
  {
    key: 5,
    path: routing.map((route) => {
      if (route.cpt === 'store') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <StoreFinder stub={routing.find((r) => r.cpt === 'store_finder')?.slug} />,
  },
  {
    key: 6,
    path: routing.map((route) => {
      if (route.cpt === 'store_finder') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <StoreFinder stub={routing.find((r) => r.cpt === 'store_finder')?.slug} />,
  },
  {
    key: 7,
    path: routing.map((route) => {
      if (route.cpt === 'assicurazioni') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => <Assicurazioni cpt="assicurazioni" />,
  },
  {
    key: 8,
    path: routing.map((route) => {
      if (route.cpt === 'garanzia') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: Garanzia,
  },
  {
    key: 9,
    path: routing.map((route) => {
      if (route.cpt === 'processo') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: Processo,
  },
  {
    key: 10,
    path: routing.map((route) => {
      if (route.cpt === 'centri_bs') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: CentriBS,
  },
  {
    key: 11,
    path: routing.map((route) => {
      if (route.cpt === 'carclinic') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: CarClinic,
  },
  {
    key: 12,
    path: routing.map((route) => {
      if (route.cpt === 'vantaggi') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: Vantaggi,
  },
  {
    key: 13,
    path: routing.map((route) => {
      if (route.cpt === 'archive_news') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <ArchivePosts
        stub={routing.find((r) => r.cpt === 'archive_news')?.slug}
        cpt="posts"
      />
    ),
  },
  {
    key: 14,
    path: routing.map((route) => {
      if (route.cpt === 'post') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: () => (
      <Post cpt="posts" stub={routing.find((r) => r.cpt === 'post')?.slug} />
    ),
  },
  {
    key: 15,
    path: routing.map((route) => {
      if (route.cpt === 'about') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: About,
  },
  {
    key: 16,
    path: routing.map((route) => {
      if (route.cpt === 'contact') return `/${lang}${route.slug}`
      return null
    }).filter((el) => el !== null),
    exact: true,
    component: Contact,
  },
  {
    key: 999,
    component: NotFound,
  },
]
